import { useEffect, useState } from "react";
import type { PlayerInfo } from "../../game/types";
import { fmtCompact, fmtInt, specLabel } from "../../game/format";
import { avatarCdnUrl } from "@cookies/shared/cdn";
import { ringStyle } from "../../game/cosmetics";

export function hoverTitle(name: string, spec: string, contribution: string | number, cps: string | number, power: string | number, level: number): string {
  return `${name} · 🍪 ${fmtInt(contribution)} total · +${fmtCompact(cps)}/s · ⚡ ${fmtCompact(power)} · Lv ${level} · ${specLabel(spec)}`;
}

export function RingAvatar({ player, lazy }: { player: PlayerInfo; lazy?: boolean }) {
  const url = avatarCdnUrl(player.userId, player.avatar ?? "", 64);
  const [failed, setFailed] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const ring = ringStyle(player.cosmetics?.ring);
  useEffect(() => {
    if (!url || failed || loaded) return;
    const t = window.setTimeout(() => setFailed(true), 1000);
    return () => window.clearTimeout(t);
  }, [url, failed, loaded]);
  if (url && !failed) {
    return <span className="bk-ring" style={{ background: player.color, padding: 0, overflow: "hidden", ...ring }} aria-hidden="true"><img src={url} alt={player.name} width={32} height={32} crossOrigin="anonymous" loading={lazy ? "lazy" : "eager"} decoding="async" style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} onLoad={() => setLoaded(true)} onError={() => setFailed(true)} /></span>;
  }
  return <span className="bk-ring" style={{ background: player.color, ...ring }} aria-hidden="true">{player.name.slice(0, 1)}</span>;
}
